export default function socketAllowsBrowserNotification(eventType, integrations = [], isMainApp = true) {
  if (!isMainApp) return true;
  const pushSettings = integrations.find((item) => item.type === 'notificationCenter');
  return Boolean(
    pushSettings
    && Array.isArray(pushSettings.eventTypes)
    && pushSettings.eventTypes.includes(eventType),
  );
}
